import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addneedpaychannelgame } from "@/api/management/rechargeChannelGameManagement";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        game: ""
      },
      gameList: [],
      rules: {
        game: [{
          required: true,
          message: this.$t('pleaseSelectGame'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init() {
      this.getGameList();
      this.dialogFormVisible = true;
    },
    getGameList: function getGameList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("d2admin/game/GameList", {
                  page_size: 1000
                });

              case 2:
                query = _context.sent;
                _this.gameList = query.data || [];

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(type) {
      this.searchData.game = "";

      if (!type) {
        this.dialogFormVisible = false;
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vaild) {
        if (vaild) {
          var reqFn = addneedpaychannelgame;
          reqFn(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(_this2.$t('operationSuccess'));
              _this2.dialogFormVisible = false;

              _this2.$emit("change");
            }
          });
        }
      });
    }
  }
};